import { Preference } from './preference.model';
import { useDefault } from '../../../../common';

export class StayPreference {
  userPreferenceSelected: boolean;
  notes: Array<string> = [];
  name: string;
  id: string;
  preferences: Preference[] = [];

  constructor(categoryData: any) {
    this.name = useDefault(categoryData.description, '');
    this.id = useDefault(categoryData.name, '');
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/stay-preferences/stay-preference.model.ts